<template>
    <div class="h-100" :class="layoutTheme.class" :style="layoutTheme.style">
        <div v-if="!isBrowserIE" class="back-off h-100">
            <!-- TODO: A changer le type de module -->
            <topbar
                :style="moduleSwitcher.width > 0 ? `margin-left: ${moduleSwitcher.width}px !important` : ''"
                :home="{ name: 'ordering_table.home' }"
                :isSidebarCollapsed="isSidebarCollapsed"
                :restaurants="restaurants"
                :user="user"
                module_type="click-and-collect"
                @module-switcher-button-clicked="moduleSwitcher.show = !moduleSwitcher.show"
                :mobileMenuDisplayed="mobileMenuDisplayed"
                @mobile-menu-updated="mobileMenuDisplayed = $event">
            </topbar>

            <div class="container-fluid h-100" :style="moduleSwitcher.show == true ? 'overflow-x: hidden;' : ''">
                <div class="row h-100">
                    <module-switcher
                        serviceId="ordering-table"
                        :isSidebarCollapsed="isSidebarCollapsed"
                        :user="user"
                        :manhattan-logo="isManhattanTheme"
                        @open="onModuleSwitcherOpen"
                        @close="closeModuleSwitcher"
                        :show="moduleSwitcher.show" />
                    <sidebar
                        :style="moduleSwitcher.width > 0 ? `margin-left: ${moduleSwitcher.width}px !important` : ''"
                        :user="user"
                        :restaurants="restaurants"
                        :isSidebarCollapsed="isSidebarCollapsed"
                        :entries="sidebarEntries"
                        :restaurantRouteName="`click_and_collect.restaurants.sales`"
                        @sidebar-collapse-changed="isSidebarCollapsed = $event"
                        @close-menu="mobileMenuDisplayed = false"
                        @reload-router-view="$emit('reload-router-view')">
                    </sidebar>

                    <main
                        role="main"
                        class="ps-0 pe-0 h-100 main"
                        :style="moduleSwitcher.width > 0 ? `margin-left: ${moduleSwitcher.width + 240}px !important` : ''"
                        :class="{
                            'col-md-12 col-lg-12': user && user.role === 'kitchen',
                            'offset-md-3 offset-lg-2 col-md-9 col-lg-10': user && user.role !== 'kitchen' && !isSidebarCollapsed,
                            'offset-md-1 offset-lg-1 col-lg-11 col-md-11': isSidebarCollapsed,
                        }">
                        <notifications style="z-index: 9999" group="notification" />

                        <slot />
                    </main>
                </div>
            </div>
            <!-- Ordering at table uses the click-and-collect subscription and its terms. -->
            <AcceptCgvModal
                v-if="showAcceptCgvModal"
                :module="MODULE_TYPE_CLICK_AND_COLLECT"
                :access-module-label="MODULE_TYPE_ORDERING_TABLE.label"
                @close="showAcceptCgvModal = false" />
        </div>
        <div v-else style="text-align: center">
            <h1>Navigateur non supporté</h1>
            <p v-html="$t('errors.browser.invalid.infos')"></p>
            <br />
        </div>
    </div>
</template>

<script>
import axios from "axios";
// load components
import Sidebar from "../Sidebar.vue";
import Topbar from "../Topbar.vue";
import ModuleSwitcher from "../ModuleSwitcher";
import ModuleTypesEnum from "../../mixins/enums/ModuleTypesEnum";
import AcceptCgvModal from "../../components/Modals/CGU/AcceptCgvModal";
import { LAYOUT_THEME_KEY, isManhattanSession, manhattanLayoutTheme } from "../../themes/manhattan";

export default {
    props: {
        user: {
            required: true,
        },
    },
    mixins: [ModuleTypesEnum],
    provide() {
        return {
            [LAYOUT_THEME_KEY]: this.layoutTheme,
        };
    },
    data: function () {
        return {
            showAcceptCgvModal: false,
            restaurant_id: this.$route.params.restaurant_id,
            submenu: false,
            selected_service_id: null,
            servicesNavbar: false,
            creditCountSms: null,
            smsActivated: null,
            isSidebarCollapsed: this.isSidebarCollapsedTablet(),
            moduleSwitcher: {
                show: false,
                height: 0,
                width: 0,
            },
            mobileMenuDisplayed: false,
        };
    },
    computed: {
        sidebarEntries() {
            return [
                {
                    to: { name: "ordering_table.restaurants.board" },
                    title: "Tableau de bord",
                    icon: "home",
                    exactUrlMatching: true,
                    rights: ["any"],
                },
                {
                    to: { name: "ordering_table.restaurants.order" },
                    title: "Commandes",
                    icon: "shopping-cart",
                    exactUrlMatching: false,
                    rights: ["click_and_collect.commands.*"],
                },
                {
                    to: { name: "ordering_table.restaurants.liveservice" },
                    title: "En cours",
                    icon: "clock",
                    exactUrlMatching: false,
                    rights: ["click_and_collect.payments.*"],
                },
                {
                    to: { name: "ordering_table.restaurants.inkitchen" },
                    title: "En cuisine",
                    icon: "zap",
                    exactUrlMatching: false,
                    rights: ["any"],
                },
                {
                    to: { name: "ordering_table.restaurants.products" },
                    title: "Produits",
                    icon: "package",
                    exactUrlMatching: false,
                    rights: ["default.customer.*"],
                },

                {
                    to: { name: "ordering_table.restaurants.configuration" },
                    title: "Configuration",
                    icon: "settings",
                    exactUrlMatching: false,
                    rights: ["click_and_collect.config.*"],
                },
            ];
        },
        restaurants() {
            return this.$store.getters["restaurants/getOrderingTableRestaurants"]();
        },
        isOwner() {
            return this.$store.getters["users/role"] === "owner";
        },
        isManhattanTheme() {
            return isManhattanSession();
        },
        layoutTheme() {
            return manhattanLayoutTheme(this.isManhattanTheme);
        },
    },
    created() {
        if (this.isOwner) this.fetchHasAcceptedCgvs();
        this.checkRestaurantId();
        this.ensureRouteRestaurantAccess();
    },
    methods: {
        isSidebarCollapsedTablet() {
            if (window.innerWidth <= 1024 && window.innerWidth > 767) {
                return true;
            } else {
                return false;
            }
        },
        onModuleSwitcherOpen({ width, height }) {
            this.moduleSwitcher.width = width;
            this.moduleSwitcher.height = height;
        },
        closeModuleSwitcher() {
            this.moduleSwitcher.width = 0;
            this.moduleSwitcher.height = 0;
            this.moduleSwitcher.show = false;
        },
        checkRestaurantId() {
            this.restaurant_id = this.$route.params.restaurant_id;
            if (!this.$route.params.restaurant_id && this.restaurants.length == 1) {
                this.restaurant_id = this.restaurants[0].id;
            }
        },
        isOrderingTableRouteWithRestaurant() {
            return typeof this.$route?.name === "string" && this.$route.name.startsWith("ordering_table.restaurants.");
        },
        isOrderingTableRestaurantAllowed(restaurantId) {
            const parsedId = Number.parseInt(restaurantId, 10);
            if (!Number.isFinite(parsedId)) {
                return false;
            }

            return this.restaurants.some((restaurant) => Number.parseInt(restaurant.id, 10) === parsedId);
        },
        ensureRouteRestaurantAccess() {
            if (!this.isOrderingTableRouteWithRestaurant()) {
                return;
            }

            const allRestaurants = this.$store.getters["restaurants/restaurants"] || [];
            const userRestaurantIds = this.$store.getters["users/restaurantIds"] || [];
            const isWaitingRestaurantsLoad = allRestaurants.length === 0 && userRestaurantIds.length > 0;
            if (isWaitingRestaurantsLoad) {
                return;
            }

            if (this.isOrderingTableRestaurantAllowed(this.$route.params.restaurant_id)) {
                return;
            }

            this.$router.replace({ name: "ordering_table.home" });
        },
        logout() {
            axios
                .post("/logout")
                .then((response) => {
                    window.location.replace(response.data.redirect_url || response.headers.location || "/login");
                })
                .catch(() => {});
        },
        fetchHasAcceptedCgvs() {
            this.loading = true;

            return axios
                .get(`/api/accepted_cgvs/modules/${this.MODULE_TYPE_CLICK_AND_COLLECT.value}`)
                .then((response) => {
                    this.loading = false;
                    this.showAcceptCgvModal = !response.data.result;
                })
                .catch(() => (this.loading = false));
        },
    },
    watch: {
        "$route.params.restaurant_id": function (id) {
            this.checkRestaurantId();
            this.ensureRouteRestaurantAccess();
        },
        restaurants() {
            this.checkRestaurantId();
            this.ensureRouteRestaurantAccess();
        },
    },
    components: {
        Sidebar,
        Topbar,
        ModuleSwitcher,
        AcceptCgvModal,
    },
};
</script>
